import {
    formatForDisplay,
    HeldKey,
    Hotkey,
    parseHotkey,
    useKeyHold,
} from '@tanstack/react-hotkeys';
import styled from 'styled-components';

const Kbd = styled.kbd<{ $show: boolean; $held: boolean }>`
    background-color: var(--background-subtle);
    color: var(--text-primary);
    border: 1px solid var(--border-default);
    border-radius: 0.3rem;
    padding: 0rem 0.3rem;
    font-size: 1.2rem;

    ${({ $show }) => !$show && 'opacity: 0;'};
    transition-property: opacity;
    transition-duration: 150ms;
    transition-delay: 250ms;
    ${({ $held }) =>
        $held && 'border-color: var(--primary-default); color: var(--primary-default)'};
`;

export type ShortcutBadgeProps = {
    hotkey: Hotkey | HeldKey;
    show: boolean;
    style?: React.CSSProperties;
};

export function ShortcutBadge({ hotkey, show, style }: ShortcutBadgeProps) {
    const parsed = parseHotkey(hotkey);
    const isHeldKey = useKeyHold(parsed.key as HeldKey);
    // in the future this may be insufficient, but fine for now
    const isHeldCtrl = useKeyHold('Control');

    return (
        <Kbd
            className="shortcut-badge"
            $show={show}
            $held={isHeldKey && (!parsed.ctrl || isHeldCtrl)}
            style={style}
        >
            {formatForDisplay(hotkey)}
        </Kbd>
    );
}
